import { Grid } from '@mantine/core';
import { ReactNode } from 'react';

// BEFORE EDITING BREAKPOINTS MAKE SURE IT WILL NOT AFFECT OTHER COMPONENTS
// USING THIS COMPONENT
const XCol3 = ({ children }: { children: ReactNode }) => {
  return (
    <Grid.Col sm={6} md={3}>
      {children}
    </Grid.Col>
  );
};

export default XCol3;
